import { noop, some } from 'lodash';
import React, { useState } from 'react';

import useWizardContext from '../hooks/useWizardContext';
import type { ErrorCollection } from '../types/Response';

type ErrorWithCollection = (Error & ErrorCollection) | ErrorCollection;

type Errors = ErrorWithCollection[];

interface ErrorHandlingContext {
  errors: Errors;
  addError(value: ErrorWithCollection): void;
  removeError(value: ErrorWithCollection): void;
}

export const Context = React.createContext<ErrorHandlingContext>({
  errors: [],
  addError: noop,
  removeError: noop
});

const ErrorHandlingProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [errors, setErrors] = useState<Errors>([]);
  const wizardContext = useWizardContext();

  return (
    <Context.Provider
      value={{
        errors,
        addError(value: ErrorWithCollection) {
          if (!some(errors, value)) {
            setErrors([...errors, value]);
          }
        },

        removeError(value: ErrorWithCollection) {
          const updatedErrors = errors.filter((error) => error !== value);
          if (!updatedErrors.length) {
            wizardContext.error = null;
          }
          setErrors(updatedErrors);
        }
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default ErrorHandlingProvider;
